import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Popup from "reactjs-popup";
import { PopupMessage } from "../../utils/utils";
import styles from "../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import ComplianceTable from "./ComplianceTable";
import Select from "react-select";
import { clientAccess } from "../../utils/index";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class ComplianceComponent extends React.Component {
  state = {
    url: `${apiUrl.apiUrl.url}/compliance/create`,
    isOpen: false,
    LandlordGroups: [],
    clientList: [],
    redirect: false,
    popupContent: "",
    messsagePopup: false,
    delete: false,
    categoryList: [],
    id: undefined,
    initialValues: {
      name: "",
      compliance_type: "",
      compliance_datatype: "",
      category: "",
      category_id: '',
    },
  };

  constructor(props) {
    super(props);
  }

  checkDelete() {
    var self = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/compliance/check-delete?id=${this.state.id}`,
    }).then(function (response) {
      if (!response.data.success) {
        self.setState({
          messsagePopup: true,
          popupContent: "Sorry you cannot delete this item"
        });

      } else {
        self.setState({
          delete: true
        });
      }
    });
  }

  componentDidMount() {


    fetch(`${apiUrl.apiUrl.url}/client-group/fetch-list`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          LandlordGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/compliance/get-compliance-category`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          categoryList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  componentDidUpdate() {
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;
      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/compliance/create`,
          initialValues: {
            name: "",
            compliance_type: "",
            compliance_datatype: "",
          },
        });
      } else {
        let athis = this;
        axios.get(`${apiUrl.apiUrl.url}/compliance/fetch-logic?id=${this.props.match.params.id}`).then((response) => {
          let data = response.data;
          athis.setState({
            url: `${apiUrl.apiUrl.url}/compliance/update?id=${athis.props.match.params.id}`,
            initialValues: data.data,
            clientList: data.clientList,
            LandlordGroups: data.LandlordGroups
          });
        }).catch((error) =>{});

        // fetch(
        //   `${apiUrl.apiUrl.url}/compliance/fetch-logic?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     this.setState({
        //       url: `${apiUrl.apiUrl.url}/compliance/update?id=${this.props.match.params.id}`,
        //       initialValues: data.data,
        //       clientList: data.clientList,
        //       LandlordGroups: data.LandlordGroups
        //     });
        //     console.log(this.state.initialValues, "iv");
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }
    }
  }
  handleChangeCategory = (newValue, actionMeta) => {
    this.state.initialValues.category = newValue.label;
    this.state.initialValues.category_id = newValue.value;
    this.setState({});
    console.group("Value Changed");
  }

  handleChangeLandlordGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionMeta", actionMeta);

    if (actionMeta == "change_client_group") {
      this.state.initialValues.groupId = newValue.value;
      this.state.initialValues.groupName = newValue.label;

      fetch(`${apiUrl.apiUrl.url}/client/client-list?groupId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            clientList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    } else {
      this.state.initialValues.clientId = newValue.value;
      this.state.initialValues.clientName = newValue.label;
      fetch(`${apiUrl.apiUrl.url}/compliance/fetch-compliance-category?clientId=` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            categoryList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      console.log("inside", actionMeta);
    }
    this.setState({});
    //this.state.initialValues.groupName = newValue.label;

    this.groupId = newValue;
    console.log(this.groupId, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  redirectToDelete = () => {
    this.setState({ delete: false });
    var ths = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/compliance/delete?id=${this.state.id}`,
    }).then(function (response) {

      if (!response.data.success) {
        ths.setState({
          messsagePopup: true,
          popupContent: "Something Went Wrong",

        });
      } else {
        ths.setState({
          messsagePopup: true,
          popupContent: "Data Deleted Successfully",
        });
      }
    });
  };

  redirectAfterSave = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        name: "",
        compliance_type: "",
        compliance_datatype: "",
      },
    });
  };

  redirectAfterEdit = () => {
    this.setState({
      redirect: true,
      messsagePopup: false,
      delete: false,
      popupContent: "",
      initialValues: {
        name: "",
        compliance_type: "",
        compliance_datatype: "",
      },
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/compliance" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>
                <Link to="/masters">Masters</Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters/commercial-logic-master">
                  Clauses Master
                </Link>
              </li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <Link to="/masters">Compliance Clauses</Link>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values);
            values.category_id = this.state.initialValues.category_id;
            var self = this;
            axios({
              method: "post",
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully!"
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      {clientAccess() && (
                        <>
                          <div className="newGridSectionInner">
                            <label>
                              Client Group <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientGroup"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_group");
                                }}
                                value={{
                                  label: this.state.initialValues.groupName,
                                  value: this.state.initialValues.groupId,
                                }}
                                options={this.state.LandlordGroups.map((item) => ({
                                  label: item.group_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientGroup"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Client Name <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="clientName"
                                onChange={(e) => {
                                  this.handleChangeLandlordGroup(e, "change_client_name");
                                }}
                                value={{
                                  label: this.state.initialValues.clientName,
                                  value: this.state.initialValues.clientId,
                                }}
                                options={this.state.clientList.map((item) => ({
                                  label: item.client_name,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="clientName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="newGridSectionInner">
                        <label>
                          Category <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <CreatableSelect
                            name="category_id"
                            onChange={(e) => {
                              this.handleChangeCategory(e);
                            }}
                            value={{
                              label: this.state.initialValues.category,
                              value: this.state.initialValues.category_id,
                            }}
                            options={this.state.categoryList.map((item) => ({
                              label: item.category,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="category_id"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Name
                        </label>
                        <div className="position-relative">
                          <Field type="text" name="name" />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Compliance Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="compliance_type"
                            onChange={(e) => {
                              this.setState({ companyType: e.target.value });
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="asset" label="Asset" />
                            <option value="unit" label="Unit" />
                          </Field>
                          <ErrorMessage
                            name="compliance_type"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>
                          Data Type <span className="astrik">*</span>
                        </label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name="compliance_datatype"
                            onChange={(e) => {
                              this.setState({ companyType: e.target.value });
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="date" label="Date" />
                            <option value="checkbox" label="Checkbox" />
                          </Field>
                          <ErrorMessage
                            name="compliance_datatype"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="update_button" disabled={isSubmitting}>
                          Update
                        </button>
                        <button
                          className="delete_button"
                          type="button"
                          onClick={(e) => {
                            this.checkDelete(e);
                          }}>
                          Delete
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          <Link to="/masters/compliance">
                            Reset
                          </Link>
                        </button>
                      </div>
                    ) : (
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button type="submit" className="add_button" disabled={isSubmitting}>
                          Add
                        </button>
                        <button type="reset" className="reset_button" onClick={this.redirectAfterEdit}>
                          Reset
                        </button>
                      </div>
                    )}
                  </div>
                </Form>
              </div>


              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">

                      {clientAccess() &&
                        <>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Group <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">

                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientGroup"
                                    //onInputChange={this.handleChange}
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_group"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.groupName,
                                      value: this.state.initialValues.groupId,
                                    }}
                                    options={this.state.LandlordGroups.map(
                                      (item) => ({
                                        label: item.group_name,
                                        value: item.id,
                                      })
                                    )}
                                  />

                                  <ErrorMessage
                                    name="clientGroup"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Client Name <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                    name="clientName"
                                    onChange={(e) => {
                                      this.handleChangeLandlordGroup(
                                        e,
                                        "change_client_name"
                                      );
                                    }}
                                    value={{
                                      label: this.state.initialValues.clientName,
                                      value: this.state.initialValues.clientId,
                                    }}
                                    options={this.state.clientList.map((item) => ({
                                      label: item.client_name,
                                      value: item.id,
                                    }))}
                                  />
                                  <ErrorMessage
                                    name="clientName"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Category <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <CreatableSelect
                                name="category_id"
                                onChange={(e) => {
                                  // handleChange(e);
                                  this.handleChangeCategory(e);

                                }}
                                value={{
                                  label: this.state.initialValues.category,
                                  value: this.state.initialValues.category_id,
                                }}
                                options={this.state.categoryList.map((item) => ({
                                  label: item.category,
                                  value: item.id,
                                }))}
                              />
                              <ErrorMessage
                                name="category_id"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Name
                            </label>
                            <div className="col-sm-7">
                              <Field type="text" name="name" />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Compliance Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="compliance_type"
                                onChange={(e) => {
                                  this.setState({ companyType: e.target.value });
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option
                                  value="asset"
                                  label="Asset"
                                />
                                <option
                                  value="unit"
                                  label="Unit"
                                />
                              </Field>
                              <ErrorMessage
                                name="compliance_type"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Data Type <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name="compliance_datatype"
                                onChange={(e) => {
                                  this.setState({ companyType: e.target.value });
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                <option
                                  value="date"
                                  label="Date"
                                />
                                <option
                                  value="checkbox"
                                  label="Checkbox"
                                />
                              </Field>
                              <ErrorMessage
                                name="compliance_datatype"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    {this.props.match.params.id !== undefined ? (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  this.checkDelete(e);
                                }}
                              >
                                Delete
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                <Link to="/masters/compliance">
                                  Reset
                                </Link>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-lg-6 offset-lg-6">
                          <div className="btnContainer">
                            <div>
                              <button type="submit" disabled={isSubmitting}>
                                Add
                              </button>
                              <button type="reset" onClick={this.redirectAfterEdit}>
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Delete the item?"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToDelete}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
        <ComplianceTable />
      </>
    );
  }
}

export default withRouter(ComplianceComponent);
